//noScroll
class Member {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const body = document.querySelector("body")

    const modalBtns = document.querySelectorAll(".modal-toggle");
      modalBtns.forEach(function (btn) {
        btn.onclick = function () {
          const modal = btn.getAttribute('data-modal');
          document.getElementById(modal).classList.add("is-active")
          body.classList.add("is-fixed")
        };
      });
      const closeBtns = document.querySelectorAll(".modal-close");
      closeBtns.forEach(function (btn) {
        btn.onclick = function () {
          var modal = btn.closest('.modal');
          modal.classList.remove("is-active")
          body.classList.remove("is-fixed")
        };
      });


    /* 役員写真切り替え  */

    const executive = document.querySelectorAll(".js-executive-click")

    executive.forEach(el => {
      el.addEventListener("click", () => {
        const revContent = el.querySelector(".js-rev-content")        
        revContent.classList.toggle("is-rev")
      })
    })


  }
}
